import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

export const setReservedIdsReducer = (state: State, action: Actions.SetReservedIds) =>
  assocPath(['reservedIds'], action.payload.ids, state);
